import { render, staticRenderFns } from "./WithToolbar.vue?vue&type=template&id=0b702a1b&scoped=true&"
var script = {}
import style0 from "./WithToolbar.vue?vue&type=style&index=0&id=0b702a1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b702a1b",
  null
  
)

export default component.exports